var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardOverImageTitle, CardWithShadow } from "../components";
import { Box, CardContent, useTheme } from "@mui/material";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useTranslation } from "react-i18next";
export function SeasonTrophiesMobileCard(props) {
    var trophyImage = props.trophyImage, title = props.title, to = props.to;
    var theme = useTheme();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    return (_jsx(CardWithShadow, __assign({ sx: __assign({ display: "flex" }, props.sx), cardHeightOverride: 264, fixedWidth: 148, to: to }, { children: _jsxs(CardContent, __assign({ sx: { zIndex: 1 }, style: { padding: "4px", width: "100%" } }, { children: [_jsx(Box, { sx: {
                        mt: "16px",
                        backgroundImage: "url(".concat(trophyImage, ")"),
                        height: "140px",
                        width: "140px",
                        mb: "30px",
                        overflow: "hidden",
                        backgroundSize: "cover"
                    } }), _jsx(CardOverImageTitle, { sx: { color: theme.palette.text.primary, mx: "auto", mt: "auto", textAlign: "center" }, title: getLocalizedString(title, currentLang) })] })) })));
}
